import Swiper from 'swiper';

const CAROUSEL_THUMBS_SELECTOR = '.js-carousel-thumbs';
export default (swiperInstance: Swiper) => {
  const thumbConfigName = `${swiperInstance.el.getAttribute('data-config')}Thumbs`;
  const thumbsWrapper = document.querySelector(`${CAROUSEL_THUMBS_SELECTOR}[data-thumbs-partner="${thumbConfigName}"]`);
  if (!thumbsWrapper) return;
  const thumbs = thumbsWrapper.querySelectorAll('.js-carousel-thumb');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const thumbSwiperInstance = thumbsWrapper.closest<HTMLElement>('.swiper-container')?.swiper;
      thumbSwiperInstance && thumbSwiperInstance.slideTo(parseInt(thumb.getAttribute('data-slide')));
      swiperInstance.slideTo(parseInt(thumb.getAttribute('data-slide')));
    });
  });
};

export const updateActiveThumb = (swiperInstance: Swiper) => {
  const thumbConfigName = swiperInstance.el.getAttribute('hasthumbs');
  const thumbsWrapper = document.querySelector(`${CAROUSEL_THUMBS_SELECTOR}[data-thumbs-partner="${thumbConfigName}"]`);
  if (!thumbsWrapper) return;
  const thumbSwiperInstance = thumbsWrapper.querySelector<HTMLElement>('.swiper')?.swiper;
  thumbSwiperInstance.slideTo(swiperInstance.realIndex);
}